import { Component } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { LastSearchService } from 'src/app/shared/services/lastSearchService';

@Component({
  selector: 'app-repeat-last-search-widget',
  template: `
    <app-dashboard-card title="Repeat Last Search">
      <button mat-stroked-button class="dashboard-action-button" (click)="repeat()">Run Last Search</button>
    </app-dashboard-card>
  `,
  styles: [
    `.dashboard-action-button { border-color: var(--mat-sys-outline, var(--sys-outline)); color: var(--mat-sys-on-surface, var(--sys-on-surface)); align-self: flex-start; width: auto; max-width: fit-content; }`,
    `.dashboard-action-button:hover { background: var(--mat-sys-surface-container-highest, var(--sys-surface-container-highest)); color: var(--mat-sys-on-surface, var(--sys-on-surface)); }`
  ]
})
export class RepeatLastSearchWidgetComponent {
  constructor(
    private readonly lastSearchService: LastSearchService,
    private readonly stateService: StateService
  ) { }

  repeat(): void {
    this.lastSearchService.getLastSearch().subscribe(result => {
      this.stateService.go(result.newState, result.stateArgs);
    });
  }
}
